import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';

import {
  StatDescription,
  StatItem,
  StatNumber,
  StatsWrapper,
} from './Stats.styled';

interface AnimatedStatProps {
  endNumber: number;
}

const AnimatedStat = ({ endNumber }: AnimatedStatProps): ReactElement => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const steps = 90;
    const increment = endNumber / steps;
    const stepDuration = duration / steps;

    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep += 1;
      setCount(Math.min(Math.round(increment * currentStep), endNumber));

      if (currentStep >= steps) {
        clearInterval(timer);
      }
    }, stepDuration);

    return () => clearInterval(timer);
  }, [endNumber]);

  return <StatNumber>{count}</StatNumber>;
};

export const Stats = (): ReactElement => {
  const [inView, setInView] = useState(false);

  return (
    <InView rootMargin="-100px" onChange={() => setInView(true)}>
      <StatsWrapper>
        <StatItem>
          {inView ? (
            <AnimatedStat endNumber={170} />
          ) : (
            <StatNumber>170</StatNumber>
          )}
          <StatDescription>stron praktycznych informacji</StatDescription>
        </StatItem>
        <StatItem>
          {inView ? (
            <AnimatedStat endNumber={170} />
          ) : (
            <StatNumber>170</StatNumber>
          )}
          <StatDescription>miejsc, które możesz odwiedzić</StatDescription>
        </StatItem>
        <StatItem>
          {inView ? (
            <AnimatedStat endNumber={35} />
          ) : (
            <StatNumber>35</StatNumber>
          )}
          <StatDescription>plaż i&nbsp;basenów naturalnych</StatDescription>
        </StatItem>
        <StatItem>
          {inView ? (
            <AnimatedStat endNumber={19} />
          ) : (
            <StatNumber>19</StatNumber>
          )}
          <StatDescription>
            szlaków trekkingowych z&nbsp; mapami
          </StatDescription>
        </StatItem>
        <StatItem>
          {inView ? (
            <AnimatedStat endNumber={62} />
          ) : (
            <StatNumber>62</StatNumber>
          )}
          <StatDescription>ciekawostki na tematy Teneryfy</StatDescription>
        </StatItem>
      </StatsWrapper>
    </InView>
  );
};
